import { getSiteConfig } from './constantFunction'
import { getTenant, publicUrl } from './tenant'

/** 划线复制追加的著作权声明（知乎同款措辞） */
export const COPYRIGHT_LINE = '著作权归作者所有。商业转载请联系作者获得授权，非商业转载请注明出处。'

/**
 * 一张卡片的署名信息：作者名取站点设置 author，空则回落 URL 里的用户名；来源是站点标题。
 * card 只需要 { id, title }。
 */
export const attributionFor = (card) => {
    const site = getSiteConfig() || {}
    return {
        title: (card && card.title) || 'Untitled',
        author: (site.author && site.author.trim()) || getTenant() || '',
        url: publicUrl('/post?note-id=' + (card ? card.id : '')),
        source: (site.title && site.title.trim()) || 'Notes',
    }
}

const signatureLines = (a) => [
    '作者：' + a.author,
    '链接：' + a.url,
    '来源：' + a.source,
]

/** 分享按钮：《标题》+ 作者 / 链接 / 来源 */
export const buildShareText = (card) => {
    const a = attributionFor(card)
    return ['《' + a.title + '》'].concat(signatureLines(a)).join('\n')
}

/** 划线复制（纯文本）：正文 + 空行 + 署名 + 著作权声明 */
export const buildQuoteText = (text, card) => {
    const a = attributionFor(card)
    return text.replace(/\s+$/, '') + '\n\n' + signatureLines(a).concat(COPYRIGHT_LINE).join('\n')
}

const escapeHtml = (s) => String(s)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;')

/** 划线复制（富文本）：选区 HTML + 署名段落（链接可点） */
export const buildQuoteHtml = (fragmentHtml, card) => {
    const a = attributionFor(card)
    const url = escapeHtml(a.url)
    return fragmentHtml
        + '<p>作者：' + escapeHtml(a.author)
        + '<br>链接：<a href="' + url + '">' + url + '</a>'
        + '<br>来源：' + escapeHtml(a.source)
        + '<br>' + COPYRIGHT_LINE + '</p>'
}
